import { SearchableCandidateTagFilterInput } from 'generated-graphql/types';
import { normaliseTagQuery } from './normaliseTagQuery';

/**
 * Scopes the tag catalog to one organization, narrowed by what was typed.
 *
 * Every word has to match, so typing more of a tag narrows the list. Each is
 * wrapped in wildcards, so a word matches anywhere inside a tag rather than
 * only at its start: `mith` finds `Recruiter:John Smith`.
 *
 * Matched against `value`, the tag as it is displayed, rather than the
 * `valueNormalized` the catalog also stores. The index does not carry that
 * field: it was renamed from `tagNormalized` after the index was created, and
 * the mapping is `dynamic: false`, so filtering on it silently returns nothing.
 * See PAD-6044.
 *
 * An empty query leaves the org clause on its own, and the catalog is listed.
 */
export const buildTagCatalogFilter = (
  organizationId: string,
  searchQuery: string
): SearchableCandidateTagFilterInput => ({
  and: [
    { organizationId: { eq: organizationId } },
    ...normaliseTagQuery(searchQuery).map((word) => ({
      value: { wildcard: `*${word}*` }
    }))
  ]
});
